export default class BackofficeMoesForm {
  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    this.setupCanLoginToggle();
    this.setupContactEmails();
  }

  setupCanLoginToggle() {
    const canLoginCheckbox = document.getElementById('can_login');
    const emailField = document.querySelector('input[name="moe[email]"]');
    const emailLabel = document.querySelector('label[for="moe_email"]');

    if (!canLoginCheckbox || !emailField || !emailLabel) {
      return;
    }

    const toggleIndicator = (enabled) => {
      if (enabled) {
        emailField.setAttribute('required', 'required');
        if (!emailLabel.querySelector('[data-required-indicator]')) {
          emailLabel.insertAdjacentHTML('beforeend', ' <span class="text-danger" data-required-indicator>*</span>');
        }
      } else {
        emailField.removeAttribute('required');
        const indicator = emailLabel.querySelector('[data-required-indicator]');
        if (indicator) {
          indicator.remove();
        }
      }
    };

    canLoginCheckbox.addEventListener('change', (event) => {
      toggleIndicator(event.target.checked);
    });

    if (canLoginCheckbox.checked) {
      toggleIndicator(true);
    }
  }

  setupContactEmails() {
    const container = document.querySelector('[data-contact-emails]');
    if (!container) {
      return;
    }

    const list = container.querySelector('[data-contact-emails-list]');
    const template = container.querySelector('template[data-contact-email-template]');
    const addButton = container.querySelector('[data-add-contact-email]');

    if (!list || !template || !addButton) {
      return;
    }

    const addField = (value = '') => {
      const clone = template.content.firstElementChild.cloneNode(true);
      const input = clone.querySelector('input[name="moe[contact_emails][]"]');
      if (input) {
        input.value = value;
      }
      list.appendChild(clone);
    };

    const ensureAtLeastOneField = () => {
      if (!list.querySelector('[data-contact-email-row]')) {
        addField();
      }
    };

    addButton.addEventListener('click', (event) => {
      event.preventDefault();
      addField();
    });

    list.addEventListener('click', (event) => {
      const removeButton = event.target.closest('[data-remove-contact-email]');
      if (!removeButton) {
        return;
      }

      event.preventDefault();
      const row = removeButton.closest('[data-contact-email-row]');
      if (row) {
        row.remove();
      }

      ensureAtLeastOneField();
    });

    ensureAtLeastOneField();
  }

  onDataChanged(data) {
  }

  onDestroy() {
  }
}
